export default "__VITE_ASSET__BPsDnP4S__"